import {useEffect, useState} from "react";

/**
 * The current time, updated every `intervalMs`, so durations, the "now" line
 * and active carts move along without a refetch.
 */
const useNow = (intervalMs: number): Date => {
    const [now, setNow] = useState<Date>(() => new Date());

    useEffect(() => {
        const timer = setInterval(() => setNow(new Date()), intervalMs);
        return () => clearInterval(timer);
    }, [intervalMs]);

    return now;
};

export default useNow;